const BFF_SERVER = process.env.REACT_APP_SERVICE_ADDRESS_WMS_BFF
const NAMESPACE = process.env.REACT_APP_NAMESPACE
const IS_SECURE = NAMESPACE !== 'dev'
const HTTP_PROTOCOL = IS_SECURE ? 'https' : 'http'

export const IS_LOCAL = NAMESPACE === 'dev'
export const IS_PROD = NAMESPACE === 'prod'
export const API_URL = `${HTTP_PROTOCOL}://${BFF_SERVER}/v1`
